import React, { useCallback } from 'react'
import Select from 'react-select'
import useDimensions from '../../../hooks/use-dimensions'

const DimensionsTaggedSelector = ({
    value = [],
    onChange = () => {}
}) => {
    const [ dimensions, { isLoading } ] = useDimensions()
    const mapDimensionToOption = d => ({ label: d.name, value: d.id })
    const options = (dimensions || []).map(mapDimensionToOption)
    const selected = (dimensions || []).filter(d => value.includes(d.id)).map(mapDimensionToOption)

    const onSelectChange = useCallback(values => {
        onChange(values ? values.map( v => v.value) : [])
    }, [onChange])

    return (
        <Select
            value={selected}
            disabled={isLoading}
            isLoading={isLoading}
            isMulti
            name="colors"
            options={options}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onSelectChange}
            placeholder='Select Dimensions'
        />
    )
}

export default DimensionsTaggedSelector